import { render, staticRenderFns } from "./job-inactive.component.html?vue&type=template&id=0bc068ec&scoped=true&"
import script from "./job-inactive.component.ts?vue&type=script&lang=ts&"
export * from "./job-inactive.component.ts?vue&type=script&lang=ts&"
import style0 from "./job-inactive.component.scss?vue&type=style&index=0&id=0bc068ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc068ec",
  null
  
)

export default component.exports